import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'
import Swiper, { Navigation, Pagination, Autoplay, Mousewheel, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import "swiper/css/free-mode";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import p5 from 'p5';
import anime from 'animejs/lib/anime.es.js';
import splt from 'spltjs';

import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";
import { doc } from 'prettier';

Splitting();


// import Slider from './Slider.js'
const body = document.body;
const select = e => document.querySelector(e);
const selectAll = e => document.querySelectorAll(e);

function customCursor() {
    var cursor = select('.js-cursor');
    var pointer = select('.cursor');
    var cursorInner = select('.cursor-circle');

    document.addEventListener('mousemove', t => {


        var curX = t.clientX;
        var curY = t.clientY;
        cursor.classList.add('!md:block');
        cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1)';



        if (t.target.matches('a')) {

            cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1.5)';

        } else if (t.target.matches('button')) {
            cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1.5)';
        } else if (t.target.matches('a *')) {
            cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1.5)';
        }
        
        
        else {
            cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1)';
        }

        if(t.target.matches('.bg-primary')) {
            cursorInner.classList.remove('!bg-primary');
        }
        else if (t.target.matches('.text-primary .reveal')) {
            cursorInner.classList.remove('!bg-primary');
        }
        else if(t.target.matches('.cursor-change')) {
            cursorInner.classList.remove('!bg-primary');
        } else {
            cursorInner.classList.add('!bg-primary');

        }


    });

    document.addEventListener('mouseleave', () => {
        cursor.classList.remove('!block');
    });

    
}

// document.addEventListener('mouseover', (event) => {
//     if(event.target.matches('.bg-primary')) {

//         console.log('hovered')

//         var cursor = document.querySelector('.js-cursor > div')

//         cursor.classList.add('!bg-secondary-tint')
//     }

// })

let Sunrise = {
    updateQuantity(line, qty){
         fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ quantity: qty, line: line })
        }).then(response => response.json())
        .then(data => {
            // fire javascript event on window
            window.dispatchEvent(new Event('cart-updated'));

        })
        .catch((error) => {
            console.error('Error:', error);
        });
    },
    updateNote(cartNote){
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: 'TEST NOTE' })
        }).then(response => response.json())
        .then(data => {

            console.log(data)
            // fire javascript event on window
            window.dispatchEvent(new Event('cart-updated'));

        })
        .catch((error) => {
            console.error('Error:', error);
        });
    },
    addSwatches(value){
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: 39992425447526,quantity: 1}] })
        }).then(response => response.json())
        .then(data => {

            console.log(data)
            // fire javascript event on window
            window.dispatchEvent(new Event('cart-updated'));

        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
}

function headingReveal() {
    splt({
        reveal: true
    });
    anime({
        targets: '.reveal',
        translateY: [60 + (window.innerWidth*.025),0],
        loop: 0,
        delay: anime.stagger(12),
        easing: 'cubicBezier(0.84,0.11,0.2,0.87)',
        complete: function(anime) {
            var completeLogEl = 'completed : ' + anime.completed;
            


            anime.animatables.forEach(node => {
                node.target.style.overflow = 'visible'
            })

          }
    });
}


function converAnimate() {
    anime({
        targets: '.conveyor-cakes--inner',
        translateX: 1440,
        duration: 30000,
        easing: 'linear',
        complete: function(anim) {
            const data = 'completed : ' + anim.completed;

            anim.restart()

            console.log(completeLogEl.value)
          }
    });

    console.log('convey')
}

let ticker = document.querySelectorAll('.ticker');
ticker.forEach(function(el){
    let tickerList = el.querySelector('.ticker--list');
    let tickerClone = tickerList.cloneNode(true);
    el.append(tickerClone);
    el.append(tickerClone.cloneNode(true));
    el.append(tickerClone.cloneNode(true));
    el.append(tickerClone.cloneNode(true));
    el.append(tickerClone.cloneNode(true));
    el.append(tickerClone.cloneNode(true));
    el.append(tickerClone.cloneNode(true));
    el.append(tickerClone.cloneNode(true));
    el.append(tickerClone.cloneNode(true));
});





Alpine.data('collectionSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Pagination, Navigation],
            // slideToClickedSlide: true,
            slidesPerView: 1.1,
            loop: true,
            preventClicks: true,
            preventClicksPropagation: true,
            spaceBetween: 20,
            pagination: {
                el: ".collectionSliderProgressEl",
                type: "fraction",
                renderFraction: function (currentClass, totalClass) {
                    return '<span class="' + currentClass + '"></span>' +
                           '/' +
                           '<span class="' + totalClass + '"></span>';
                }
            },
            navigation: {
                nextEl: ".collectionSliderNavigation-next",
                prevEl: ".collectionSliderNavigation-prev",
              },
            breakpoints: {
                // when window width is >= 480px
                300: {
                  slidesPerView: 1.1,
                  spaceBetween: 10,
                },
                // when window width is >= 640px
                1023: {
                    spaceBetween: 20,
                }
            }
        });

        swiper.on('sliderMove', (sl) => {

            var cursor = select('.js-cursor');
            var pointer = select('.cursor');
            var cursorInner = select('.cursor-circle');
        
        
            var e = window.event;

            var curX = sl.touches.currentX;
            var curY = e.clientY;
        
            console.log(curX)
            console.log(curY)
        
            cursor.classList.add('!md:block');
            cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1.5)';
            cursorInner.classList.add('!opacity-100')

        })
    }
}));

Alpine.data('retailerSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            grabCursor: true,
            loop: false,
            breakpoints: {
                // when window width is >= 480px
                300: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                }
            }
        });

        swiper.on('sliderMove', (sl) => {

            if(sl.slides.length > 3) {
                var cursor = select('.js-cursor');
                var pointer = select('.cursor');
                var cursorInner = select('.cursor-circle');
    
                var e = window.event;
    
                var curX = sl.touches.currentX;
                var curY = e.clientY;
    
                cursor.classList.add('!md:block');
                cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1.5)';
                cursorInner.classList.add('!opacity-100')
            }
        })

    }
}));

Alpine.data('newDropsSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            grabCursor: true,
            loop: false,
            breakpoints: {
                // when window width is >= 480px
                300: {
                  slidesPerView: 2.5,
                  spaceBetween: 20,
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                }
            }
        });

        swiper.on('sliderMove', (sl) => {

            var cursor = select('.js-cursor');
            var pointer = select('.cursor');
            var cursorInner = select('.cursor-circle');
        
        
            var e = window.event;

            var curX = sl.touches.currentX;
            var curY = e.clientY;
        
            console.log(curX)
            console.log(curY)
        
            cursor.classList.add('!md:block');
            cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1.5)';
            cursorInner.classList.add('!opacity-100')

        // cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1)';
        
        
    
        })
        
    }
}));


Alpine.data('whatsIncludedSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            grabCursor: false,
            loop: false,
            breakpoints: {
                // when window width is >= 480px
                300: {
                  slidesPerView: 2.5,
                  spaceBetween: 20,
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 6,
                    spaceBetween: 20,
                }
            }
        });

        swiper.on('sliderMove', (sl) => {

            var cursor = select('.js-cursor');
            var pointer = select('.cursor');
            var cursorInner = select('.cursor-circle');
        
        
            var e = window.event;

            var curX = sl.touches.currentX;
            var curY = e.clientY;
    
        
            cursor.classList.add('!md:block');
            cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1.5)';
            cursorInner.classList.add('!opacity-100')

        // cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1)';
        

        })


        
    }
}));





Alpine.data('bestSellersSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            grabCursor: true,
            breakpoints: {
                // when window width is >= 480px
                300: {
                  slidesPerView: 2.5,
                  spaceBetween: 20,
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                }
            }
        });

        swiper.on('sliderMove', (sl) => {

            var cursor = select('.js-cursor');
            var pointer = select('.cursor');
            var cursorInner = select('.cursor-circle');
        
        
            var e = window.event;

            var curX = sl.touches.currentX;
            var curY = e.clientY;
        
            console.log(curX)
            console.log(curY)
        
            cursor.classList.add('!md:block');
            cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1.5)';
            cursorInner.classList.add('!opacity-100')

        // cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1)';
        
        

        })
    }
}));

Alpine.data('madeSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Navigation],
            slidesPerView: 3.5,
            spaceBetween: 20,
            navigation: {
                nextEl: ".made-slider-button-next",
                prevEl: ".made-slider-button-prev",
            },
        });
    }
}));

Alpine.data('blogSliderHero', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Navigation, Pagination, EffectFade],
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: ".blogSliderProgressEl",
                type: "fraction",
                renderFraction: function (currentClass, totalClass) {
                    return '<span class="' + currentClass + '"></span>' +
                           '/' +
                           '<span class="' + totalClass + '"></span>';
                }
            },
            navigation: {
                nextEl: ".blog-slider-button-hero-next",
                prevEl: ".blog-slider-button-hero-prev",
            }
        });
    }
}));

// blogSlider

Alpine.data('blogSlider', () => ({
    initSlider(element) {
        // Start of Selection
        const swiper = new Swiper(element, {
            modules: [Navigation],
            slidesPerView: 1,
            loop: true,
            spaceBetween: 20,
            navigation: {
                nextEl: ".blog-slider-button-next",
                prevEl: ".blog-slider-button-prev",
            },
            breakpoints: {
                767: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        });
    }
}));



Alpine.data('discoverSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            slidesPerView: 1.3,
            centeredSlides: true,
            loop: true,
            breakpoints: {
                640: {
                  slidesPerView: 1.3
                },
                1024: {
                  slidesPerView: 3
                },
              },
        });
    }
}));

Alpine.data('discoverSliderDesktop', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            slidesPerView: 1.3,
            centeredSlides: true,
            loop: true,
            mousewheel: true,
            breakpoints: {
                640: {
                  slidesPerView: 1.3
                },
                1024: {
                  slidesPerView: 3.3
                },
              },
        });
    }
}));

Alpine.data('feedSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Autoplay],
            centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 2000,
            },
            breakpoints: {
                // when window width is >= 480px
                300: {
                  slidesPerView: 3,
                  spaceBetween: 12,
                  centeredSlides: true,
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 7.2,
                    spaceBetween: 14,
                    centeredSlides: true,
                }
            }
        });
    }
}));


Alpine.data('productSliderMobile', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Pagination],
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
              }
        });
    }
}))
Alpine.data('productSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Navigation],
            slidesPerView: 1,
            navigation: {
                nextEl: ".product-slider-button-next",
                prevEl: ".product-slider-button-prev",
            },
        });

        swiper.on('slideChange', function () {
            myCallbackfunction(this);
        
          });
        
        function myCallbackfunction(data){
            console.log(data.realIndex);

            let index = data.realIndex
            //console.log(data);

            document.querySelectorAll(`.active-slider--btn`).forEach(node => {
                node.classList.remove('active-slider--btn')
            })
        
            document.querySelector(`.product-custom-slide-${index}`).classList.add('active-slider--btn')
    
        }
    },
    navigateTo(element, index) {
        console.log(index)
        console.log(element.swiper)

        element.swiper.slideTo(index, 150, true)

        document.querySelectorAll(`.active-slider--btn`).forEach(node => {
            node.classList.remove('active-slider--btn')
        })
    
        document.querySelector(`.product-custom-slide-${index}`).classList.add('active-slider--btn')

    }
}));



Alpine.data('collectionCtaSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Mousewheel],
            slidesPerView: 'auto',
            grabCursor: true,
            centeredSlides: false,
            mousewheel: true,
            spaceBetween: 30,
            initialSlide: 2,
            loop: false,
            direction: 'horizontal'
        });
    }
}));

if(window.innerWidth >= 1023 && document.getElementById('drawContainer')){
    let x;
    let y;
    let col;
    let el = document.getElementById('drawContainer');

    const sketch = (s) => {
        s.setup = () => {
            s.createCanvas(s.windowWidth, el.clientHeight);
            s.background(255);
            s.noStroke();
            s.frameRate(200);
        }

        s.draw = () => {
            col = s.random(0, 255);

            x = s.lerp(col, s.mouseX, '.5');
            y = s.lerp(col, s.mouseY, '.5');

            let color1 = s.map(s.mouseX, 0, s.windowWidth, 27, 241);
            let color2 = s.map(s.mouseY, 0, s.windowHeight, 128, 249);
            let color3 = s.map(s.mouseX, 0, s.windowWidth, 109, 219);


            let circleSize = s.random(150, 150)

            s.ellipse(s.mouseX, s.mouseY, circleSize, circleSize);

        s.fill(color1, color2, color3);

        if (s.mouseIsPressed) {
            s.clear();
        }
    }
}
    const sketchInstance = new p5(sketch, 'drawContainer');
}



// GEOLOCATION

/* https://colour-mill.myshopify.com/browsing_context_suggestions.json?source=geolocation_recommendation&currency[enabled]=true&currency[exclude]=AUD&language[enabled]=true */



var geoLocate = async function () {

// let url = 'https://colour-mill.myshopify.com/browsing_context_suggestions.json?source=geolocation_recommendation&currency[enabled]=true&currency[exclude]=AUD&language[enabled]=true&language[exclude]=en&country[enabled]=true'
let url = '/browsing_context_suggestions.json?source=geolocation_recommendation&currency[enabled]=true&currency[exclude]=AUD&language[enabled]=true&language[exclude]=en&country[enabled]=true'

let fetchAPI = await fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Origin': 'colour-mill' }
})
  .then(res => res.json())
  .then(data => {
        passData(data)
  })
}

geoLocate()


const passData = (data) => {
    const userLxocal = data.detected_values.country.handle

    const elementsToLocate = document.querySelectorAll('.locate')

    var productLocaleCount = []



    elementsToLocate.forEach(node => {
        if(!node.classList.contains('hidden')) {
            productLocaleCount.push(' ')
        }
    })


        const productCount = productLocaleCount.length


    const productCountDisplay = document.querySelector('#ProductCount')


    if(productCountDisplay) {
        productCountDisplay.innerHTML = `${productCount} Products`
    }

    // TODO UPDATE PRODCUT COUNT



    const eu = ['PT', 'BE' ,'BG' ,'CZ' ,'DK' ,'DE' ,'EE' ,'IE' ,'EL' ,'ES' ,'FR' ,'HR' ,'IT' ,'CY' ,'LV' ,'LT','LU','HU','MT','NL','PL','RO','SI', 'SK', 'FI', 'SE', 'ME', 'MK', 'AL', 'RS', 'TR', 'NO']




    elementsToLocate.forEach((node) => {


        let local = node.dataset.local

        console.log(userLxocal)

        // EU
        if((eu.includes(userLxocal)) && (node.classList.contains('data-show-eu'))) {
            node.classList.add('block')
            node.classList.remove('hidden')
        }

        if((eu.includes(userLxocal) ) && (node.classList.contains('data-hide-eu'))) {
            node.classList.add('hidden')
            node.classList.remove('block')
        }

        // US 
        if((userLxocal === 'US') && (node.classList.contains('data-show-us'))) {

            node.classList.add('block')
            node.classList.remove('hidden')
        }

        if((userLxocal === 'US')  && (node.classList.contains('data-hide-us'))) {
            node.classList.add('hidden')
            node.classList.remove('block')
        }


        // UK
        if((userLxocal === 'GB') && (node.classList.contains('data-show-uk'))) {

            node.classList.add('block')
            node.classList.remove('hidden')
        }

        if((userLxocal === 'GB')  && (node.classList.contains('data-hide-uk'))) {
            node.classList.add('hidden')
            node.classList.remove('block')
        }

        // AU Only
        if((userLxocal !== 'AU')  && (node.classList.contains('data-aus-only'))) {
            node.classList.add('hidden')
            node.classList.remove('block')
        }

    })

}




Alpine.data('articleImageSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Mousewheel],
            slidesPerView: 1.3,
            spaceBetween: 20,
            freeMode: true,
            mousewheel: {
                forceToAxis: true
            },
            breakpoints: {
                640: {
                  slidesPerView: 1.3
                },
                1024: {
                  slidesPerView: 1.8
                },
              }
        });

        swiper.on('sliderMove', (sl) => {

            var cursor = select('.js-cursor');
            var pointer = select('.cursor');
            var cursorInner = select('.cursor-circle');
        
        
            var e = window.event;

            var curX = sl.touches.currentX;
            var curY = e.clientY;
        

        
            cursor.classList.add('!md:block');
            cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1.5)';
            cursorInner.classList.add('!opacity-100')

        // cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1)';
        
    
        })
    }
}));


Alpine.data('whatsIncludedSliderBlog', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            grabCursor: false,
            loop: false,
            breakpoints: {
                // when window width is >= 480px
                300: {
                  slidesPerView: 2.5,
                  spaceBetween: 20,
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                }
            }
        });

        swiper.on('sliderMove', (sl) => {

            var cursor = select('.js-cursor');
            var pointer = select('.cursor');
            var cursorInner = select('.cursor-circle');
        
        
            var e = window.event;

            var curX = sl.touches.currentX;
            var curY = e.clientY;
        
            console.log(curX)
            console.log(curY)
        
            cursor.classList.add('!md:block');
            cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1.5)';
            cursorInner.classList.add('!opacity-100')

        // cursor.style.transform = 'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%)) scale(1)';
        
        })
        
    }
}));

Alpine.data('mainBlog', () => ({
    currentPage: 1,
    articlesPerPage: 12,
    selectedFilters: {
      color: null,
      productType: null,
      category: 'All'
    },
    articles: [],
    hasNextPage: false,
    lastCursor: null,
    isLoading: false,

    async fetchFilteredArticles(loadMore = false) {
      this.isLoading = true;
      
      // Use a larger page size when filters are active
      const pageSize = this.hasActiveFilters() ? 250 : this.articlesPerPage;
      
      // First fetch articles with their metafields
      const response = await fetch('/api/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': 'b3f445ac6a4f84cf32e70c21f7cd7e93'
        },
        body: JSON.stringify({
          query: `query($cursor: String) {
            blog(handle: "colour-mill") {
              articles(
                first: ${pageSize}, 
                after: $cursor,
                sortKey: PUBLISHED_AT,
                reverse: true
              ) {
                edges {
                  cursor
                  node {
                    handle
                    title
                    excerpt
                    publishedAt
                    onlineStoreUrl
                    image {
                      url
                      altText
                      width
                      height
                    }
                    colorMetafield: metafield(namespace: "custom", key: "colour") {
                      value
                    }
                    typeMetafield: metafield(namespace: "custom", key: "product_types") {
                      value
                    }
                    filterMetafield: metafield(namespace: "custom", key: "filterby") {
                      value
                    }
                    hoverImage: metafield(namespace: "custom", key: "hover_image") {
                      value
                    }
                  }
                }
                pageInfo {
                  hasNextPage
                  endCursor
                }
              }
            }
          }`,
          variables: {
            cursor: loadMore ? this.lastCursor : null
          }
        })
      }).then(res => res.json());

      let newArticles = response.data.blog.articles.edges.map(edge => edge.node);
      
      // Update pagination info - only show Load More when no filters are active
      this.hasNextPage = !this.hasActiveFilters() && response.data.blog.articles.pageInfo.hasNextPage;
      this.lastCursor = response.data.blog.articles.edges[response.data.blog.articles.edges.length - 1]?.cursor;
      
      // Collect all hover image IDs
      const hoverImageIds = newArticles
        .map(article => article.hoverImage?.value)
        .filter(id => id);

      // Fetch hover images if any exist
      if (hoverImageIds.length > 0) {
        const hoverImages = await this.fetchHoverImages(hoverImageIds);
        
        // Create a map of image IDs to their URLs
        const imageMap = new Map(
          hoverImages.map(img => [img.id, img.image?.url])
        );

        // Add hover image URLs to articles
        newArticles = newArticles.map(article => ({
          ...article,
          hoverImageUrl: article.hoverImage ? imageMap.get(article.hoverImage.value) : null
        }));
      }

      // If color filter is active, fetch color metaobjects
      if (this.selectedFilters.color) {
        const colorMetaobjects = await this.fetchColorMetaobjects(
          newArticles.map(article => {
            try {
              return JSON.parse(article.colorMetafield?.value || '[]');
            } catch (e) {
              console.error('Error parsing color IDs:', e);
              return [];
            }
          }).flat()
        );

        // Create a map of color IDs to their names
        const colorMap = new Map(
          colorMetaobjects.map(obj => {
            const label = obj.fields.find(f => f.key === 'name')?.value;
            return [obj.id, label];
          })
        );

        // Filter articles with colorMap
        newArticles = this.filterArticles(newArticles, colorMap);
      } else {
        // If no color filter, just filter without colorMap
        newArticles = this.filterArticles(newArticles);
      }

      // Append or replace articles based on loadMore flag
      this.articles = loadMore ? [...this.articles, ...newArticles] : newArticles;
      this.isLoading = false;
    },

    hasActiveFilters() {
      return this.selectedFilters.color !== null || 
             this.selectedFilters.productType !== null || 
             this.selectedFilters.category !== 'All';
    },

    filterArticles(articles, colorMap = null) {
      return articles.filter(article => {
        let matches = true;
        
        // Color filter
        if (this.selectedFilters.color && colorMap) {
          try {
            const articleColorIds = JSON.parse(article.colorMetafield?.value || '[]');
            const articleColors = articleColorIds.map(id => colorMap.get(id));
            matches = matches && articleColors.includes(this.selectedFilters.color);
          } catch (e) {
            console.error('Error processing article colors:', e);
            matches = false;
          }
        }
        
        // Product type filter
        if (this.selectedFilters.productType) {
          try {
            const types = JSON.parse(article.typeMetafield?.value || '[]');
            matches = matches && types.includes(this.selectedFilters.productType);
          } catch (e) {
            console.error('Error processing product types:', e);
            matches = false;
          }
        }
        
        // Category filter
        if (this.selectedFilters.category !== 'All') {
          matches = matches && article.filterMetafield?.value === this.selectedFilters.category;
        }
        
        return matches;
      });
    },

    loadMore() {
      if (this.hasNextPage && !this.isLoading) {
        this.currentPage++;
        this.fetchFilteredArticles(true);
      }
    },

    async fetchColorMetaobjects(ids) {
      if (!ids.length) return [];
      
      const response = await fetch('/api/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': 'b3f445ac6a4f84cf32e70c21f7cd7e93'
        },
        body: JSON.stringify({
          query: `{
            nodes(ids: ${JSON.stringify(ids)}) {
              ... on Metaobject {
                id
                fields {
                  key
                  value
                }
              }
            }
          }`
        })
      }).then(res => res.json());

      return response.data.nodes;
    },

    async fetchHoverImages(ids) {
      if (!ids.length) return [];
      
      const response = await fetch('/api/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': 'b3f445ac6a4f84cf32e70c21f7cd7e93'
        },
        body: JSON.stringify({
          query: `{
            nodes(ids: ${JSON.stringify(ids)}) {
              ... on MediaImage {
                id
                image {
                    url
                }
              }
            }
          }`
        })
      }).then(res => res.json());

      return response.data.nodes;
    },

    async init() {
      await this.fetchFilteredArticles();
      
      // Listen for filter changes from facets-blog
      window.addEventListener('filter-changed', (event) => {
        const { type, value } = event.detail;
        
        if (type === 'reset') {
          this.selectedFilters.color = null;
          this.selectedFilters.productType = null; 
          this.selectedFilters.category = 'All';
        } else {
          this.selectedFilters[type] = value;
        }

        this.currentPage = 1;
        this.lastCursor = null;
        this.fetchFilteredArticles(false);
      });
    }
  }));


function checkCommonValues(arr1, arr2) {
    return arr1.some(item => arr2.includes(item));
}

function arraysAreEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }

    return arr1.every((item, index) => item === arr2[index]);
}
function isSubset(subset, superset) {
    return subset.every(item => superset.includes(item));
}

window.isSubset = isSubset;
window.arraysAreEqual = arraysAreEqual;
window.checkCommonValues = checkCommonValues;
customCursor();
window.Anime = anime;
window.splt = splt;
window.headingReveal = headingReveal;
window.converAnimate = converAnimate;
window.geoLocate = geoLocate;
window.Alpine = Alpine
Alpine.plugin(persist)
Alpine.plugin(collapse)
Alpine.plugin(intersect)

window.Swiper = Swiper;

Alpine.start()

window.Sunrise = Sunrise
